<template>
    <modal :show.sync="modals.modal1" footerClasses="text-right"  :largeModal="true">
      <h6 slot="header" class="modal-title text-success font-weight-bold" id="modal-title-default">
        Cek Status BPHTB
      </h6>
      <div class="d-block">
            <ValidationObserver v-slot="{ handleSubmit }">
              <form ref="form" @submit.stop.prevent="handleSubmit(tracking)">
                <div class="mb-5">
                  <div class="container pt-lg-md">
                    <div class="row">
                      <div class="col-lg-6">
                            <div class="form-group">
                              <label>
                                Nomor Pelayanan
                                <span>*</span>
                              </label>
                          <masked-input
                            v-model="form.no_pelayanan"
                            class="form-control"
                            mask="11111111"  />
                          </div>
                          <div class="text-left">
                            <template v-if="isBusy">
                              <pulse-loader :loading="isBusy" :color="'#d7f6e8'"></pulse-loader>
                              <strong>Loading...</strong>
                            </template>
                            <base-button v-else type="primary" nativeType="submit" icon="ni ni-send" class="my-4">Cari
                            </base-button>
                          </div>
                      </div>
                    </div>
                    <!--  v-if="trackingData.length > 0" -->
                    <div class="row"> 
                        <div class="table-responsive-sm col-md-12">
                          <table class="
                              table
                              b-table
                              table-hover table-bordered table-sm
                            ">
                            <thead>
                              <tr class="
                                  tr-values
                                  vs-table--tr
                                  tr-table-state-null
                                ">
                                <th style="width: 50px">No.</th>
                                <th>Status</th>
                                <th>Keterangan</th>
                                <th>Aksi</th>
                                <th>Tanggal</th>
                              </tr>
                            </thead>
                            <tbody>
                                <tr class="tr-values vs-table--tr tr-table-state-null" v-for="(tr, indextr) in trackingData"  :key="indextr">
                                    <td>{{indextr+1}}</td>
                                    <td><b>{{tr.status_verifikasi == '1' ? 'Sudah Verifikasi' : 'Belum Verifikasi'}}</b></td>
                                    <td>{{tr.keterangan_verifikasi}}</td>
                                    <td>Oleh : {{tr.user.username}}</td>
                                    <td>{{tr.createdtime}}</td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                        </div>
                  </div>
                </div>
              </form>
            </ValidationObserver>
      </div>
    </modal>
  </template>
  
  <script>
  import Modal from "@/components/Modal.vue";
  import PulseLoader from "vue-spinner/src/PulseLoader.vue";
  import { ValidationProvider, ValidationObserver } from "vee-validate";
  import qs from "qs";
  import axios from "axios";
  import Swal from "sweetalert2";
import MaskedInput from "vue-masked-input";
  
  export default {
    components: {
      Modal,
      PulseLoader,
      ValidationProvider,
      ValidationObserver,
      MaskedInput
    },
    data() {
      return {
        modals: {
          modal1: false,
        },
        form: {
            no_pelayanan: null,
        },
        trackingData: [],
        isBusy: false,
      };
    },
    methods: {
      showModal() {
        this.form.no_pelayanan = null;
        this.modals.modal1 = true;
      },
      hideModal() {
        this.modals.modal1 = false;
      },
      async tracking() {
        const me = this;
        try {
          this.isBusy = true;
          axios.get("/api/v1/bphtb/get-data-verifikasi?no_permohonan=" + me.form.no_pelayanan).then(function (response) {
            me.trackingData = response.data;
          }).finally(() => {
            me.isBusy = false;
          });
        } catch (error) {
          // console.log(errors);
        } finally {
          this.isBusy = false;
        }
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .modal-dialog {
    max-width: 80% !important;
    margin: 1.75rem auto;
  }
  </style>